<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mosaic`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4h8v8H4V4zm16 8h-8v8H4v8h8v8H4v8h8v-8h8v8h8v-8h8v8h8v-8h-8v-8h8v-8h-8v-8h8V4h-8v8h-8V4h-8v8zm0 8h-8v8h8v8h8v-8h8v-8h-8v-8h-8v8zm0 0h8v8h-8v-8z"/></svg>
</template>
<script>

export default {
  name: 'IconMosaic',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
